var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-slot",class:{'confirmed': _vm.confirmed}},[_c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":_vm.product.thumb}})]),_c('div',{staticClass:"copy"},[_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.product.name))]),_c('div',{staticClass:"price"},[_vm._v("¥"+_vm._s(_vm.product.price))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }